<template lang="pug">
div.has-fixed-footer
    .card.mb-3(v-if="parentCollection")
        .card-body.py-2
            strong Parent collection:
            span.ml-2
                router-link(:to="'/collections/' + parentCollection.id") {{parentCollection.name}}
                span.text-muted.ml-2 ({{parentCollection.id}})
    CollectionEditCard(v-model="collection" :createMode="true" @changedCollection="onChanged")
</template>

<script>
import CollectionEditCard from "./CollectionEditCard.vue";
import {getCollection} from "../api";
import {country, badCharsRegex} from "../../config.json";

const badChars = new RegExp(badCharsRegex, "g");

export default {
    components: {CollectionEditCard},
    data() {
        return {
            collection: {
                country,
                biobank: localStorage.getItem("biobank"),
                parent_collection: null,
                contact: null,
                head: null,
                type: ["SAMPLE"],
                materials: ["NAV"],
                data_categories: ["NAV"],
                storage_temperatures: [],
                network: [],
                sex: [],
                diagnosis_available: [],
                body_part_examined: [],
                imaging_modality: [],
                image_dataset_type: [],
                sop_New: {
                  "sample_processing_sop" : false,
                  "sample_transport_sop" : false,
                  "sample_storage_sop" : false,
                  "data_processing_sop" : false,
                  "data_transport_sop" : false,
                  "data_storage_sop" : false
                },
                access_fee_New: { images: false, samples: false, data: false},
                access_joint_project_New: { images: false, samples: false, data: false}
                //all ARRAY attributes must be listed here
            },
          isChanged: false,
          parentCollection: null
        };
    },
    watch: {
        "collection.name"(name) {
            let prefix = this.collection.biobank + ":collection:";
            if (this.collection.parent_collection)
                prefix = this.collection.parent_collection + ":";
            this.collection.id = prefix + name.replace(badChars, "");
        }
    },
    created() {
      Object.assign(this.collection, this.$route.query);
      if (this.collection.parent_collection) {
        getCollection(this.collection.parent_collection)
          .then(parent => {
            this.parentCollection = parent;
            this.collection.biobank = parent.biobank || this.collection.biobank;
            this.collection.country = parent.country || this.collection.country;
            if (!this.collection.contact) this.$set(this.collection, "contact", parent.contact || null);
            if (!this.collection.head) this.$set(this.collection, "head", parent.head || null);
          })
          .catch(() => this.parentCollection = null);
      }
      this.scrollToTop();
    },
  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        const appMain = document.querySelector(".app-main");
        if (appMain) appMain.scrollTop = 0;
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    },
    onChanged(isChanged) {
      console.log(this.isChanged);
      this.isChanged = isChanged;
    }
  }
}
</script>
